import { useState, useEffect } from 'react';
import { transform } from '../Pages/SearchResult/Utils.jsx';

const libCodeMap = {
  嘉義市政府文化局: 'cabcy',
  國家圖書館: 'ncl',
  國立臺灣圖書館: 'cwktrial',
  基隆市文化局: 'klccab',
  彰化雲端電子書庫: '',
  新北市立圖書館: 'tpc',
  新竹市圖書館: '',
  新竹縣政府文化局: '',
  桃園市立圖書館: 'tyccc',
  澎湖縣圖書館: 'phhcc',
  臺中市立圖書館: 'taich',
  臺北市立圖書館: 'tpml',
  臺南市立圖書館: 'tnml',
  臺東縣政府文化處: 'ttct',
  花蓮縣文化局: 'hlshcc',
  苗栗市立圖書館: '',
  苗栗縣立圖書館: 'miaoli',
  連江縣公共圖書館: '',
  金門縣文化局: '',
  高雄市立圖書館: 'ksm',
};

const useUdnSearch = (cities, searchBookName) => {
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const activeLibraries = Object.entries(cities)
      .filter(([_, isActive]) => isActive)
      .map(([name]) => ({ name, code: libCodeMap[name] }))
      .filter(({ code }) => !!code); // 過濾沒有 libCode 的

    if (!searchBookName || activeLibraries.length === 0) {
      setResults([]);
      setLoading(false);
      setError(null);
      return;
    }

    const fetchData = async () => {
      setLoading(true);
      setError(null);

      try {
        const allResults = [];

        await Promise.all(
          activeLibraries.map(async ({ name, code }) => {
            const url = `https://reading.udn.com/udnLibService/libraryProduct/v4/searchBookData/${code}?kw=${encodeURIComponent(
              searchBookName
            )}&opt=all&sort=B&page=1&amount=20`;

            try {
              const res = await fetch(url);
              const data = await res.json();

              if (data?.status === 200 && Array.isArray(data?.data?.products)) {
                const mapped = data.data.products.map((p) => ({
                  title: p.name,
                  link: `https://reading.udn.com/udnlib/${code}/B/${p.iid}`,
                  library: name,
                }));
                allResults.push(...mapped);
              }
            } catch (err) {
              console.warn(`Fetch failed for ${name}: ${err.message}`);
            }
          })
        );

        setResults(allResults);
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [cities, searchBookName]);

  return { results: transform(results), loading, error };
};

export default useUdnSearch;
